import { render, staticRenderFns } from "./FocusArea.vue?vue&type=template&id=75d4ec04&scoped=true&"
import script from "./FocusArea.vue?vue&type=script&lang=js&"
export * from "./FocusArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d4ec04",
  null
  
)

export default component.exports